import { render, staticRenderFns } from "./StatusHistoryView.vue?vue&type=template&id=7bc81a7d"
import script from "./StatusHistoryView.vue?vue&type=script&lang=js"
export * from "./StatusHistoryView.vue?vue&type=script&lang=js"
import style0 from "./StatusHistoryView.vue?vue&type=style&index=0&id=7bc81a7d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports